import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import Tab from '../../../../components/tabs';
import DateNews from './dateNews';
import Live from './live/';

class NewsLive extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        current: 0,
        selected: true,
    };

    handleTabsChange = index => {
        this.setState({ current: index });
    };

    handleSelected = () => {
        const { selected } = this.state;

        this.setState({ selected: !selected });
    };

    /**
     * 渲染组件
     */
    render() {
        const { current, selected } = this.state;
        const { content } = this.props;

        const title = {
            id: '230039',
            type: 'struct',
            title: '要闻直播主标题',
            groupName: '正文',
            content: content.newsLiveTab,
        };

        return (
            <div className={styles.news_live}>
                <Tab current={current} title={title} ad={content.dayNewsAd} handleTabsChange={this.handleTabsChange} />
                <div style={{ display: current === 0 ? 'block' : 'none' }}>
                    <div className={styles.stock_news}>
                        <DateNews
                            dayMainNew0={content.dayMainNew0}
                            dayMainNew1={content.dayMainNew1}
                            extraNews={content.extraNews}
                            extraNewsAd={content.extraNewsAd}
                        />
                    </div>
                </div>
                <div style={{ display: current === 0 ? 'none' : 'block' }}>
                    <Live
                        content={content.liveLogo}
                        current={current}
                        selected={selected}
                        handleSelected={this.handleSelected}
                    />
                </div>
            </div>
        );
    }
}

export default errorBoundary(NewsLive);
